<template>
    <modal show-on-mount 
        @hide="$emit('hide', $event)"
        @hidden="$emit('hidden')"
           
        ref="modal"

        :options="{ close: { onBlur: false, onEsc: false } }"
        :size="size"
    >
        <template #modal-title>
            <slot name="title" />
        </template>
        
        <template #modal-body>
            <slot name="body" />
        </template>
        
        <template #modal-footer>
            <settings-controls
                :invalid="invalid"
                :delete-button-text="resources.deleteButtonText"

                @save="onSave()"
                @cancel="hide()"
                @delete="$emit('delete')"
            />
        </template>
    </modal>
</template>

<script>
import {validationMixin} from 'vuelidate';
import resourceMixin from "@core/Util/Mixins/resources";

import Modal, { sizes } from "@core/Components/Util/Modal";
import SettingsControls from "./SettingsControls";

export default {
    name: "settings-popup-base",
    components: {
        Modal,
        SettingsControls
    },
    mixins: [validationMixin, resourceMixin],
    
    props: {
        /**
         * @property {String} deletePromptTitle
         * @property {String} deletePromptBody
         * @property {String} deleteButtonText
         */
        resources: {
            type: Object,
            required: true
        },

        invalid: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    
    data() {
        return {
            size: sizes.medium
        }
    },
    
    methods: {
        hide() {
            this.$refs.modal.hide();
        },
        
        onSave() {
            if(this.invalid){
                this.displayErrors();
                return;
            }
            
            this.$emit('save');
        },

        displayErrors(){
            this.$emit('display-errors');
        }
    }
}
</script>
